import React from "react";
import { Helmet } from 'react-helmet-async';


const About = () => {
  return (
    <div className="max-w-4xl mx-auto p-8 text-center text-[#00F0FF] bg-[#121212] rounded-lg shadow-lg border border-[#00F0FF]">
      <Helmet>
        <title>About Us | BrowserArena</title>
        <meta
          name="description"
          content="Learn more about BrowserArena, your ultimate destination for free online browser games."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About BrowserArena",
            "url": "https://browserarena.com/about",
            "description": "Learn more about BrowserArena — your portal for the best free online browser games."
          })}
        </script>
        <link rel="canonical" href={`https://browserarena.com/about`} />
      </Helmet>
      <h1 className="text-4xl font-bold mb-6 text-[#FF007F]">About Us</h1>
      <p className="text-lg mb-4">
        Welcome to <span className="font-semibold text-[#FFD700]">Browser Arena</span>, where fun meets innovation! Our mission is to provide an exciting online gaming experience for players of all ages.
      </p>
      <p className="text-lg mb-4">
        Founded by passionate developers, we continually update our game library to ensure fresh, engaging content. Whether you're looking to unwind or challenge yourself, we have something for everyone!
      </p>
      <p className="text-lg mb-6">
        Join our community and explore the endless possibilities of online gaming!
      </p>
      <a
        href="/"
        className="inline-block bg-[#00F0FF] text-[#121212] px-6 py-3 rounded-lg font-semibold text-lg hover:bg-[#FF007F] transition-all shadow-md hover:shadow-lg"
      >
        Explore Our Games
      </a>
    </div>
  );
};

export default About;